import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { observable } from 'mobx';
import FetchView from '../../../dumb/FetchView/FetchView';
import { Table, TableCell, TableHead, TableBody, TableRow, IconButton, TextField } from '@material-ui/core';
import { Container, Modal, Heading, Button } from 'react-bulma-components';
import DeleteIcon from '@material-ui/icons/Delete';
import AccountsStore from 'stores/AccountsOverview/AccountsStore';
import { toast } from 'react-toastify';

@observer
class ManagerList extends Component {
  @observable accessor localstate = {
    search: '',
    newManagerName: '',
    showCreateConfirmation: false,
    showAddManagerModal: false,
    showDeleteConfirmation: false,
    managerToDelete: null,
  };

  filterList(item) {
    const search = this.localstate.search.toLowerCase();
    if (!search) return true;

    if (item.name && item.name.toLowerCase().includes(search)) return true;

    return false;
  }

  sortList(a, b) {
    const key = 'name';
    const prev = a[key];
    const next = b[key];
    return prev === next ? 0 : prev > next ? 1 : -1;
  }

  handleDelete = async () => {
    const { managerToDelete } = this.localstate;
    try {
      await AccountsStore.deleteItem(managerToDelete,'managers');
      toast.success('Manager deleted successfully.');
      this.localstate.showDeleteConfirmation = false;
      this.localstate.managerToDelete = null;
    } catch (error) {
      console.error('Failed to delete item:', error);
      toast.error('Failed to delete manager.');
    }
  };

  openDeleteConfirmation = (item) => {
    this.localstate.showDeleteConfirmation = true;
    this.localstate.managerToDelete = item;
  };

  closeDeleteConfirmation = () => {
    this.localstate.showDeleteConfirmation = false;
    this.localstate.managerToDelete = null;
  };

  openAddManagerModal = () => {
    this.localstate.showAddManagerModal = true;
  };

  closeAddManagerModal = () => {
    this.localstate.showAddManagerModal = false;
    this.localstate.newManagerName = '';
  };

  handleCreateManager = () => {
    const { newManagerName } = this.localstate;
    const existingManager = AccountsStore.list.managers.find(manager => manager.name === newManagerName && !manager.soft_deleted);

    if (existingManager) {
      toast.error('Manager already exists.');
    } else {
      this.localstate.showCreateConfirmation = true;
    }
  };

  handleConfirmCreate = async () => {
    const { newManagerName } = this.localstate;
    try {
      await AccountsStore.createItem({ name: newManagerName }, 'managers');
      toast.success('Manager created successfully.');
      this.localstate.showCreateConfirmation = false;
      this.localstate.newManagerName = '';
      this.localstate.showAddManagerModal = false;
    } catch (error) {
      toast.error('Failed to create manager.');
    }
  };

  render() {
    const { search, newManagerName, showCreateConfirmation, showAddManagerModal, showDeleteConfirmation } = this.localstate;
    const { isOpen, onClose } = this.props;

    return (
      <Modal show={isOpen} onClose={onClose}>
        <Modal.Card style={{ width: '65%' }}>
          <Modal.Card.Header>
            <Modal.Card.Title>Manage Key Account Managers</Modal.Card.Title>
          </Modal.Card.Header>
          <Modal.Card.Body>
            <Container style={{ padding: '20px' }}>
              <Heading style={{ textAlign: 'center', margin: '30px 0' }}>Key Account Managers</Heading>
              <Button onClick={this.openAddManagerModal} style={{ marginBottom: '20px', float: 'right' }}>
                Add Manager
              </Button>
              <FetchView stores={[AccountsStore]}>
                <Table aria-label="simple table" stickyHeader style={{ marginTop: '15px' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: '80%' }}>Name</TableCell>
                      <TableCell style={{ width: '20%' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(AccountsStore?.list?.managers || [])
                      .filter(this.filterList.bind(this))
                      .sort(this.sortList.bind(this))
                      .map((item, i) => (
                        <TableRow key={i}>
                          <TableCell style={{ width: '80%' }}>{item.name}</TableCell>
                          <TableCell style={{ width: '20%' }}>
                            <IconButton
                              color="secondary"
                              onClick={() => this.openDeleteConfirmation(item)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </FetchView>
            </Container>
          </Modal.Card.Body>
          <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
            <Button color="grey" onClick={onClose} style={{ width: '150px' }}>Close</Button>
          </Modal.Card.Footer>
        </Modal.Card>

        <Modal show={showAddManagerModal} onClose={this.closeAddManagerModal}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Add New Manager</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <TextField
                label="Manager Name"
                value={newManagerName}
                onChange={(e) => (this.localstate.newManagerName = e.target.value)}
                fullWidth
              />
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button color="success" onClick={this.handleCreateManager}>Add</Button>
              <Button onClick={this.closeAddManagerModal}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>

        <Modal show={showCreateConfirmation} onClose={() => (this.localstate.showCreateConfirmation = false)}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Confirm Creation</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <p>Do you want to create a new manager with the name "{newManagerName}"?</p>
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button color="success" onClick={this.handleConfirmCreate}>Yes, Create</Button>
              <Button onClick={() => (this.localstate.showCreateConfirmation = false)}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>

        <Modal show={showDeleteConfirmation} onClose={this.closeDeleteConfirmation}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Confirm Deletion</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <p>Are you sure you want to delete this manager?</p>
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button onClick={this.handleDelete}>Yes, Delete</Button>
              <Button onClick={this.closeDeleteConfirmation}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>
      </Modal>
    );
  }
}

export default ManagerList;